import { postRequest } from '@/libs/axios'

// 产品配置相关接口
export const productChannelPage = (params) => {
  return postRequest('/ndt/productChannel/page', params)
}

export const productChannelInsert = (params) => {
  return postRequest('/ndt/productChannel/insert', params)
}

export const productChannelUpdate = (params) => {
  return postRequest('/ndt/productChannel/update', params)
}

export const productChannelDelete = (params) => {
  return postRequest('/ndt/productChannel/delete', params)
}

export const channelInfoList = (params) => {
  return postRequest('/ndt/channelInfo/list', params)
}

// 渠道分组相关接口
export const channelGroupPage = (params) => {
  return postRequest('/ndt/channelGroup/page', params)
}

export const channelGroupCreate = (params) => {
  return postRequest('/ndt/channelGroup/create', params)
}

export const channelGroupUpdate = (params) => {
  return postRequest('/ndt/channelGroup/update', params)
}

export const channelGroupDelete = (params) => {
  return postRequest('/ndt/channelGroup/delete', params)
}

// 邮编分区相关接口
export const deliveryDispatchList = (params) => {
  return postRequest('/ndt/postalCodeZones/distinctList', params)
}

// 单号规则相关接口
export const numberRuleList = (params) => {
  return postRequest('/ndt/numberInterval/list', params)
}

// 国家列表相关接口
export const getAllCountry = (params) => {
  return postRequest('/ndt/isoCountry/getAllCountry', params)
}

